// extracted by mini-css-extract-plugin
export default {"container":"feed_container__67gQx","innerContainer":"feed_innerContainer__pOoVL"};